import { MapPin, Heart, Users, Sparkles, PawPrint } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";
import { GraphicBackground } from "./GraphicBackground";

interface Props {
  backgroundDataUrl?: string;
}

export const InstagramPost2Minimal = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  const points = [
    { emoji: "📍", text: "Mapa schronisk w Polsce" },
    { emoji: "🚨", text: "Pilne potrzeby wyróżnione" },
    { emoji: "🐕", text: "Spacery z psami" },
    { emoji: "🤝", text: "Wolontariat na miejscu" },
    { emoji: "📲", text: "Gotowe grafiki do udostępnienia" },
  ];
  
  return (
    <GraphicBackground
      width={1080}
      height={1080}
      bgImage={bgImage}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Main content */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "90px 80px",
          height: "100%",
          boxSizing: "border-box",
        }}
      >
        {/* Header with sparkle */}
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "12px",
              background: "rgba(78, 138, 110, 0.12)",
              padding: "12px 28px",
              borderRadius: "100px",
              marginBottom: "24px",
            }}
          >
            <Sparkles style={{ width: "24px", height: "24px", color: "#4E8A6E" }} />
            <span style={{ fontSize: "22px", fontWeight: 700, color: "#4E8A6E" }}>
              Nowość!
            </span>
          </div>
          <h1
            style={{
              fontSize: "80px",
              fontWeight: 800,
              color: "#2D5A3D",
              margin: "0",
              lineHeight: 1.05,
            }}
          >
            Co znajdziesz<br />na stronie?
          </h1>
        </div>

        {/* Checklist style */}
        <div
          style={{
            background: "rgba(255,255,255,0.97)",
            borderRadius: "32px",
            padding: "40px 48px",
            width: "100%",
            maxWidth: "800px",
            boxShadow: "0 20px 60px rgba(0,0,0,0.08)",
          }}
        >
          {points.map((point, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "24px",
                padding: "20px 0",
                borderBottom: i < points.length - 1 ? "2px solid #E8F5EA" : "none",
              }}
            >
              <span style={{ fontSize: "42px" }}>{point.emoji}</span>
              <span
                style={{
                  fontSize: "32px",
                  fontWeight: 700,
                  color: "#2D5A3D",
                }}
              >
                {point.text}
              </span>
            </div>
          ))}
        </div>

        {/* CTA and logo */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <div
            style={{
              background: "linear-gradient(135deg, #4E8A6E 0%, #3D7A5E 100%)",
              borderRadius: "100px",
              padding: "18px 48px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              boxShadow: "0 8px 32px rgba(78, 138, 110, 0.35)",
            }}
          >
            <Heart style={{ width: "28px", height: "28px", color: "#FFFFFF", fill: "#FFFFFF" }} />
            <span style={{ fontSize: "28px", fontWeight: 800, color: "#FFFFFF" }}>
              Sprawdź i pomóż!
            </span>
          </div>
          
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <div
              style={{
                background: "#4E8A6E",
                borderRadius: "14px",
                width: "52px",
                height: "52px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
            >
              <PawPrint style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
            </div>
            <span style={{ fontSize: "32px", fontWeight: 800, color: "#2D5A3D" }}>
              GdzieSchronisko
            </span>
          </div>
        </div>
      </div>
    </GraphicBackground>
  );
};

